import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg"

function FavorisActif(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={35} height={35} fill="none" viewBox="0 0 35 35" {...props}>
            <Rect width={35} height={35} fill={baseColors.green.primary} rx={7} />
            <G clipPath="url(#clip0_37:599)">
                <Path
                    fill="#fff"
                    d="M24.96 15.753a.796.796 0 00-.685-.547l-4.33-.393-1.712-4.007a.797.797 0 00-1.467 0l-1.71 4.007-4.332.393a.799.799 0 00-.453 1.395l3.273 2.87-.965 4.25a.797.797 0 001.187.862l3.734-2.232 3.733 2.232a.796.796 0 001.187-.862l-.965-4.25 3.273-2.87a.798.798 0 00.232-.848z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0_37:599">
                    <Path fill="#fff" d="M0 0h15v15H0z" transform="translate(10 10)" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default FavorisActif
